/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsIcMemoryTotalFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsIcMemoryTotalFormat = ClosedEnum<
  typeof GetApiV3MetricsIcMemoryTotalFormat
>;

export type GetApiV3MetricsIcMemoryTotalRequest = {
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Subnet ID
   */
  subnet?: string | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsIcMemoryTotalFormat | undefined;
  /**
   * Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsIcMemoryTotalFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsIcMemoryTotalFormat
> = z.nativeEnum(GetApiV3MetricsIcMemoryTotalFormat);

/** @internal */
export const GetApiV3MetricsIcMemoryTotalFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsIcMemoryTotalFormat
> = GetApiV3MetricsIcMemoryTotalFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsIcMemoryTotalFormat$ {
  /** @deprecated use `GetApiV3MetricsIcMemoryTotalFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MetricsIcMemoryTotalFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsIcMemoryTotalFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsIcMemoryTotalFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsIcMemoryTotalRequest$inboundSchema: z.ZodType<
  GetApiV3MetricsIcMemoryTotalRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsIcMemoryTotalFormat$inboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/** @internal */
export type GetApiV3MetricsIcMemoryTotalRequest$Outbound = {
  start: number | null;
  subnet: string | null;
  end: number | null;
  format: string;
  step: number;
};

/** @internal */
export const GetApiV3MetricsIcMemoryTotalRequest$outboundSchema: z.ZodType<
  GetApiV3MetricsIcMemoryTotalRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MetricsIcMemoryTotalRequest
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsIcMemoryTotalFormat$outboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsIcMemoryTotalRequest$ {
  /** @deprecated use `GetApiV3MetricsIcMemoryTotalRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsIcMemoryTotalRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsIcMemoryTotalRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsIcMemoryTotalRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsIcMemoryTotalRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsIcMemoryTotalRequest$Outbound;
}

export function getApiV3MetricsIcMemoryTotalRequestToJSON(
  getApiV3MetricsIcMemoryTotalRequest: GetApiV3MetricsIcMemoryTotalRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsIcMemoryTotalRequest$outboundSchema.parse(
      getApiV3MetricsIcMemoryTotalRequest,
    ),
  );
}

export function getApiV3MetricsIcMemoryTotalRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3MetricsIcMemoryTotalRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsIcMemoryTotalRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsIcMemoryTotalRequest' from JSON`,
  );
}
